import type { Location } from "react-router";

const scrollRestorationKeyProperty = "scrollRestorationKey";

const isStateRecord = (state: unknown): state is Record<string, unknown> =>
  !!state && typeof state === "object" && !Array.isArray(state);

export const createScrollRestorationState = () => ({
  [scrollRestorationKeyProperty]: crypto.randomUUID(),
});

export const getScrollRestorationStateKey = (
  state: unknown,
): string | undefined => {
  if (!state || typeof state !== "object") return undefined;

  const key = Reflect.get(state, scrollRestorationKeyProperty);
  return typeof key === "string" ? key : undefined;
};

export const preserveScrollRestorationState = (
  location: Pick<Location, "pathname" | "search" | "state">,
  state?: unknown,
): Record<string, unknown> => ({
  ...(isStateRecord(location.state) ? location.state : {}),
  ...(isStateRecord(state) ? state : {}),
  [scrollRestorationKeyProperty]:
    getScrollRestorationStateKey(location.state) ??
    `${location.pathname}${location.search}`,
});
